import { Button, ButtonGroup } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import "./VehiclesTypeButton.sass";

export default function VehiclesTypeButton () {
    const dispatch = useDispatch();
    const { t } = useTranslation('translation', { keyPrefix: 'components.headerNav' });
    const { vehiclesType } = useSelector(state => state.dashboardData);

    const types = [
        { name: t('btnVehicle'), value: 'vehicle' },
        { name: t('btnEquipment'), value: 'equipment' },
        { name: t('btnBoth'), value: 'both' },
    ];

    const setVehiclesType = (type) => {
        dispatch({
            type: 'SET_VEHICLES_TYPE',
            payload: type,
        })
    }

    return (
        <ButtonGroup
            className="vehicles-radio-button"
            size="sm"
        >
            {types.map((type) => (
                <Button
                    key={`vehicle_type_${type.value}`}
                    onClick={() => setVehiclesType(type.value)}
                    variant={type.value === vehiclesType ? 'primary' : 'secondary'}
                >
                    {type.name}
                </Button>
            ))}
        </ButtonGroup>
    )
}
